// extracted by mini-css-extract-plugin
module.exports = {"root":"_a31caa","icon":"_adcb59"};